"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgMenuHamburger(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M4 14h16v-2H4zm0-5h16V7H4zm0-5h16V2H4z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('MenuHamburger')(SvgMenuHamburger);
//# sourceMappingURL=MenuHamburger.js.map